/**
 * Mapping between world coordinates (blocks, y up) and the screen (CSS pixels, y down) for
 * one view. The renderers compute screen positions themselves through this object instead
 * of using a flipped canvas transform, so sprites and text are never mirrored.
 */
export class ViewTransform {
  /** The view's rectangle on the canvas, CSS px. */
  x = 0;
  y = 0;
  w = 1;
  h = 1;
  /** World coordinates of the left and bottom edges, and the zoom (CSS px per block). */
  left = 0;
  bottom = 0;
  ppb = 40;

  set(
    rect: { x: number; y: number; w: number; h: number },
    left: number,
    bottom: number,
    ppb: number,
  ): void {
    this.x = rect.x;
    this.y = rect.y;
    this.w = rect.w;
    this.h = rect.h;
    this.left = left;
    this.bottom = bottom;
    this.ppb = ppb;
  }

  /** World x at the right edge. */
  get right(): number {
    return this.left + this.w / this.ppb;
  }

  /** World y at the top edge. */
  get top(): number {
    return this.bottom + this.h / this.ppb;
  }

  sx(x: number): number {
    return this.x + (x - this.left) * this.ppb;
  }

  sy(y: number): number {
    return this.y + this.h - (y - this.bottom) * this.ppb;
  }

  /** A length in blocks as CSS px. */
  len(blocks: number): number {
    return blocks * this.ppb;
  }
}
